import { Pipe, PipeTransform } from '@angular/core';




const typeLookup = {
  1: 'OUTGOING',
  2: 'INCOMING',
  3: "DIVERSION",
  4: "TRANSFER",
  6: "PICKED_UP",
  8: "CALLBACK",
  9: "TRANSFERRED",
  10: "PICK_UP",
  11: "CONTINUATION"
};

@Pipe({
  name: 'telepoCdrType'
})
export class TelepoCdrTypePipe implements PipeTransform {
  transform(value: number): any {
    
    return typeLookup[value];
  }
}
